import {
  ALERT_PAYMENT_STATUS,
  ALERT_PAYMENT_MODE,
  ALERT_PAYMENT_MODE_VALUE,
  PAYMENT_ALERT_MESSAGE,
} from "constants/alert";
import { get } from "../utils/helpers";
import { toLowerCase } from "./toLowerCase";
import { paymentInfoInterface } from "@nykaa/payment-sdk/src/Payment/@types";
import { PaymentAlertConfig } from "./@types";
import { PAYMENT_MODES } from "constants/paymentModes";

/**
 * function to get payment alert config for a payment method
 * @param paymentAlertInfo
 * @param mode
 * @param name
 * @returns alertConfig
 */

/**
 * paymentAlertInfo response for UPI:-
 [
  {
    "mode": "upi",
    "status": 1,
    "bankName": [
      "Google Pay"
    ],
    "message": "<value> is temporarily facing issues. Please try another payment method to pay."
  }
]
*/

/*
 * @todo - we need to refactor the alerting function for all payment methods.
 */
export const getPaymentAlert = (
  paymentAlertInfo: { mode: string; bankName: [string]; message: string },
  mode: string = "",
  paymentInfo?: paymentInfoInterface,
  selectedBankName?: string
): PaymentAlertConfig => {
  let alertClass = "";
  let alertMessage = "";
  let isPaymentEnabled = true;
  let isPaymentMethodVisible = true;
  let lessPriority = false;

  // incase of last payment info
  if (mode === "last" && paymentInfo) {
    mode = toLowerCase(paymentInfo?.lastPaymentInfo?.paymentMode);
    const alert = get(paymentAlertInfo, `${mode}`);
    // incase of alert has a message then we will show the static message
    if (alert?.message) {
      alertMessage = PAYMENT_ALERT_MESSAGE.PAYMENT_METHOD_EXPERIENCING_ISSUES;
    }

    if (alert?.status === ALERT_PAYMENT_STATUS.DISABLE) {
      isPaymentEnabled = false;
    } else if (alert?.status === ALERT_PAYMENT_STATUS.HIDE) {
      isPaymentEnabled = false;
      isPaymentMethodVisible = false;
    }

    return {
      alertClass,
      alertMessage,
      isPaymentEnabled,
      isPaymentMethodVisible,
      lessPriority,
    };
  }

  if (!mode) {
    return {
      alertClass,
      alertMessage,
      isPaymentEnabled,
      isPaymentMethodVisible,
      lessPriority,
    };
  }

  const alert = get(paymentAlertInfo, `${mode}`);

  if (!alert) {
    return {
      alertClass,
      alertMessage,
      isPaymentEnabled,
      isPaymentMethodVisible,
      lessPriority,
    };
  }
  const name: string = mode === PAYMENT_MODES.UPI ? selectedBankName ? selectedBankName : "UPI" : mode;

  const { bankName, message } = alert;

  // get the alert bank display name for message. incase we don't have bankName it will return empty string;
  const getDisplayBankNameForAlert = () => {
    if (Array.isArray(bankName)) {
      return bankName.toString();
    }
    return "";
  };

  const displayBankName = getDisplayBankNameForAlert();

  if (mode == ALERT_PAYMENT_MODE.UPI) {
    // incase of upi coming in payment alert and bankName is empty/ BHIM UPI is missing
    if (Array.isArray(bankName) && !bankName.length) {
      bankName.push(ALERT_PAYMENT_MODE_VALUE.UPI);
    }
  }

  if (alert.status === ALERT_PAYMENT_STATUS.DISABLE) {
    alertClass = "disable-payment-mode";
    if (message) {
      alertMessage = message.replace("<value>", selectedBankName ? selectedBankName : displayBankName);
    }
    isPaymentEnabled = false;
    lessPriority = true;
  } else if (alert.status === ALERT_PAYMENT_STATUS.NORMAL) {
    if (message) {
      if (
        Array.isArray(bankName) &&
        bankName.length &&
        ((mode === ALERT_PAYMENT_MODE.UPI && !selectedBankName) || bankName.includes(name))
      ) {
        alertMessage = message.replace("<value>", selectedBankName ? selectedBankName : displayBankName);
      }
    }
  } else if (alert.status === ALERT_PAYMENT_STATUS.WARNING) {
    alertClass = "warn-payment-mode";
    lessPriority = true;
    if (message) {
      if (
        Array.isArray(bankName) &&
        bankName.length &&
        ((mode === ALERT_PAYMENT_MODE.UPI && !selectedBankName) || bankName.includes(name))
      ) {
        alertMessage = message.replace("<value>", selectedBankName ? selectedBankName : displayBankName);
      }
    }
  } else if (alert.status === ALERT_PAYMENT_STATUS.HIDE) {
    alertClass = "hide-payment-mode";
    isPaymentEnabled = false;
    isPaymentMethodVisible = false;
    lessPriority = true;
  }

  return {
    alertClass,
    alertMessage,
    isPaymentEnabled,
    isPaymentMethodVisible,
    lessPriority,
  };
};
